import React from 'react';

import { useItem } from './hooks/use-context';

export const Table: React.FC = () => {
  const { sections } = useItem();

  const questions = sections.find(
    (section) => section.section_name === 'Informações levantadas',
  )?.questions;

  const parentQuestions = sections
    .find((section) => section.section_name === 'Informações levantadas')
    ?.questions.filter((question) =>
      question?.answers.every((answer) => !answer.question_parent_option_id),
    );

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        fontSize: '10px',
        marginBottom: '10px',
      }}
    >
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          border: '1px solid #ddd',
          marginBottom: '10px',
          breakInside: 'avoid',
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '4px',
                textAlign: 'center',
                backgroundColor: '#FAE0CD',
                width: '57%',
              }}
            >
              Desvios
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '4px',
                textAlign: 'center',
                backgroundColor: '#e6e6e6',
                width: '5%',
              }}
            >
              Sim
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '4px',
                textAlign: 'center',
                backgroundColor: '#e6e6e6',
                width: '5%',
              }}
            >
              Não
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '4px',
                textAlign: 'center',
                backgroundColor: '#e6e6e6',
                width: '33%',
              }}
            >
              Observações
            </th>
          </tr>
        </thead>
        <tbody>
          {parentQuestions?.map((question, index) => {
            const questionChildren = questions?.filter((q) =>
              q.answers.every(
                (answer) =>
                  answer.question_parent_option_id ===
                  question.answers?.[0].content,
              ),
            );

            return (
              <tr key={index}>
                <td style={{ border: '1px solid #ddd', padding: '4px' }}>
                  {question.name}
                </td>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '4px',
                    textAlign: 'center',
                  }}
                >
                  <div
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '1px solid #000',
                      display: 'inline-block',
                      textAlign: 'center',
                      color:
                        question.answers?.[0].option === 'Sim'
                          ? 'black'
                          : 'white',
                    }}
                  >
                    X
                  </div>
                </td>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '4px',
                    textAlign: 'center',
                  }}
                >
                  <div
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '1px solid #000',
                      display: 'inline-block',
                      textAlign: 'center',
                      color:
                        question.answers?.[0].option === 'Não'
                          ? 'black'
                          : 'white',
                    }}
                  >
                    X
                  </div>
                </td>
                <td style={{ border: '1px solid #ddd', padding: '4px' }}>
                  {questionChildren?.[0]?.answers?.[0]?.content}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div
        style={{
          backgroundColor: '#E0F4E9',
          padding: '10px',
          borderRadius: '6px',
        }}
      >
        <div
          style={{
            width: '100%',
            minHeight: '100px',
            borderRadius: '6px',
            padding: '6px 10px',
            backgroundColor: '#FFFFFF',
          }}
        >
          <h3 style={{ marginBottom: '6px', fontSize: '12px' }}>Conclusão:</h3>
          <div>
            {sections
              .flatMap((section) => section.questions)
              .find(
                (question) =>
                  question.question_id ===
                  '24bdd5ef-9333-4293-a528-c3643bfdd8e4',
              )
              ?.answers?.map((answer) => (
                <div>{answer.option}</div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
